import axios from 'axios'
import uuid from 'react-native-uuid'
import env from '@lib/env'
const API_URL = env().API_URL

type GenericResponse = {
  message: string
}

interface PhotoPayload {
  id: string
  base64: string
}

interface PhotoResponse {
  fileURL: string
}

interface PhotoDeleteResponse {
  status: number
}

type NewWorkOrderPayload = WorkOrderRequest
type NewWorkOrderResponse = GenericResponse
type PendingWorkOrdersResponse = {
  data: WorkOrderRequest[]
}

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default {
  /**
   *
   * @param payload
   */
  async uploadPhoto (payload : PhotoPayload): Promise<PhotoResponse> {
    const resp = await api.post('/work-orders/new/photos', payload)

    return resp.data
  },

  /**
   *
   * @param key: string
   */
  async deletePhoto (key: string): Promise<PhotoDeleteResponse> {
    const resp = await api.delete(`/work-orders/photos/${key}`)
    return resp
  },

  /**
   *
   * @param payload
   */
  async createWorkOrder (payload: NewWorkOrderPayload): Promise<NewWorkOrderResponse> {
    payload.id = uuid.v4() as string
    payload.photos = payload.photos?.map((photo) => {
      delete photo.base64
      delete photo.uri
      return photo
    })

    const resp = await api.post('/work-orders/new', payload)
    return resp.data
  },

  /**
   *
   * @param email
   */
  async getPendingWorkOrders (email: string): Promise<PendingWorkOrdersResponse> {
    const resp = await api.get(`/work-orders/${email}`)

    /** Need to parse details JSON */
    resp.data.data = resp.data.data.map((workOrder: any) => {
      workOrder.details = JSON.parse(workOrder.details || '')
      return workOrder
    })

    return resp.data
  },
}
